import { supabase } from './supabaseClient';
import type { PrimaryAnalysis } from '../types/primaryAnalysis';

const fileToImage = (file: File) => new Promise<{ data: string; mimeType: string }>((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const value = String(reader.result || '');
    const data = value.includes(',') ? value.slice(value.indexOf(',') + 1) : value;
    resolve({ data, mimeType: file.type || 'image/jpeg' });
  };
  reader.onerror = () => reject(new Error(`Could not read ${file.name}`));
  reader.readAsDataURL(file);
});

export async function analyzeItem(files: File[]): Promise<PrimaryAnalysis> {
  const images = await Promise.all(files.slice(0, 5).map(fileToImage));
  const { data, error } = await supabase.functions.invoke('thriftalyze-analyze', { body: { images } });
  if (error) throw new Error(error.message || 'Analysis request failed');
  if (!data?.success || !data.analysis) throw new Error(data?.message || 'Analysis could not be completed');
  return data.analysis as PrimaryAnalysis;
}

export async function retryMarketplaceAnalysis(identified: PrimaryAnalysis): Promise<PrimaryAnalysis> {
  const { data, error } = await supabase.functions.invoke('thriftalyze-analyze', { body: { identified } });
  if (error) throw new Error(error.message || 'Marketplace search failed');
  if (!data?.success || !data.analysis) throw new Error(data?.message || 'Marketplace search could not be completed');
  return data.analysis as PrimaryAnalysis;
}
